import axios from "axios";
import { _authHeader } from "../auth._header";
import helpers from "@/helpers/helper";

const API_URL = helpers.API_ENDPOINT;

class ModelService {
    getModels(data) {
        return axios.get(API_URL + "models", { params:helpers.params(data), headers: _authHeader(), }).then((response) => {
            return response.data;
        });
    };
    getModelSelect() {
        return axios.get(API_URL + "model-select", {headers: _authHeader(), }).then((response) => {
            return response.data;
        });
    };
}

export default new ModelService();